import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa6";

import File1 from "./../../assets/pdf/hsdc-services-rules_1.pdf";
import File2 from "./../../assets/pdf/hsdc-services-rules_2.pdf";
import File3 from "./../../assets/pdf/hsdc-services-rules_3.pdf";
import Loader from '../Loader/Loader';
import BaseUrl from '../../base-api';
import axios from 'axios';
import { toast } from 'react-toastify';
const News = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const [notifications, setNotifications] = useState([]);
  
    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const resNote = await axios.post(
            `${BaseUrl}/api/notifications/getNotification`,
            { location: "Home Page" },
            {
              headers: { "Content-Type": "application/json" },
            }
          );
  
          if (resNote.data.status === 200) {
            setNotifications(
              resNote.data.data.map((img) => ({
                id: img.key,
                title: img.title,
                file: `data:application/pdf;base64,${img.file}` || "",
                location: img.location,
              }))
            );
          } else {
            toast.error("Failed to fetch Notifications.");
          }
        } catch (error) {
          toast.error(error.response?.data?.message || "An error occurred");
        } finally {
          setLoading(false);
        }
      };
  
      if (location.pathname) fetchData();
    }, [location.pathname]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
    <div className="container my-3">

    <div className="abouts">
        <h5>Latest News / Announcements</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

    <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <span>S.No</span>
                </th>
                <th>
                  <span>Services Rules</span>
                </th>
                
                <th>
                  <span>
                    Document{" "}
                    <span style={{ fontSize: "12px" }}>(pdf, English)</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
 {notifications.length > 0 ? (
                  notifications.map((notification,index) => (
                    <tr>
                    <td>
                      <span>{index +1}</span>
                    </td>
                    <td>
                      <strong>
                     {notification.title} 
                      </strong>
                    </td>
                    
                    <td className="text-center align-middle">
                    <a
                          href={notification.file}
                          target="_blank"
                          rel="noopener noreferrer"
                          download={`${notification.title}.pdf`}
                          style={{ textDecoration: "none" }}
                        >
                           <FaFilePdf style={{ fontSize: "25px" }} />
                        </a>
                    </td>
                  </tr>
                  ))
                ) : (
                    <tr>
                <td colSpan={3}>
                    None
                    </td>
                    </tr>
                )}

            

            </tbody>
          </table>
        </div>
        </div>
    </div>
    )}
    </>

  )
}

export default News